import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { ApplicationState } from '../Store';
import { GetBasicSettings } from '../Store/Tenant';
import { GetPortalText } from '../Store/PortalAssets';

import { PortalTextLogin, PortalTextBorrowerAnonymousSubmission } from '../Models/Api/strongbox.financialportal';

import { DefaultTOULink } from '../Utils/Constants';

import './Main.scss';

type InjectedReduxState = {
    TOULink: string;
    anonSubmissionText?: PortalTextBorrowerAnonymousSubmission;
    loginText?: PortalTextLogin;
};

type InjectedActionCreators = {};

type StrongboxTOUProps = {
    className?: string;
};

type Props = InjectedReduxState & InjectedActionCreators & StrongboxTOUProps;


const StrongboxTOUComponent: React.FC<Props> = (props): React.ReactElement => {
    return (
        <div className={props.className}>
            <span>{ `${props.anonSubmissionText?.tosPrefix || ''}` } <a className={'normal-link-color'} href={props.TOULink} rel={'noopener noreferrer'} target="_blank">{`${props.loginText?.brandName || ''} ${props.anonSubmissionText?.tosHyperlinkText || ''}.`}</a></span>
        </div>
    )
}

export const StrongboxTOU = connect<InjectedReduxState, InjectedActionCreators, StrongboxTOUProps, ApplicationState>(
    (appState: ApplicationState) => {
        const basicSettings = GetBasicSettings(appState);

        const result:InjectedReduxState = {
            TOULink: (!!basicSettings && basicSettings.TOULink) || DefaultTOULink,
            anonSubmissionText: GetPortalText<PortalTextBorrowerAnonymousSubmission>(appState, 'borrowerAnonymousSubmission'),
            loginText: GetPortalText<PortalTextLogin>(appState, 'loginPage'),
        };

        return result;
    },
    dispatch => bindActionCreators(
        {
        },
        dispatch
    )
)(StrongboxTOUComponent);
